// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { MAX_CONTRACT_LIMIT } from '@hooks/other/useGetPrepareTwoStepTransfer';
import { Error } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

export const MaxLimitErrorMessage: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', pt: 1 }}>
      <Error fontSize="small" sx={{ mr: 1 }} color="error" />
      <Typography variant="body2" color="error">
        The number of contracts required to complete this action exceeds max limit of{' '}
        {MAX_CONTRACT_LIMIT} contracts.{' '}
        <b>
          Please contact your operator to assist with the merging of the holdings for this
          instrument.
        </b>
      </Typography>
    </Box>
  );
};
